<template>
    <transition name="fade">
        <div>
            <img class="Terms-logoTycos" ref="logo" src="@/assets/img/logo.svg" alt="Carta Blanca" />
            <article class="TermsTextTycosFront" id="tycos-text" v-html="tycos"></article>
            <div class="Terms-close" @click="$emit('close')" />
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            tycos: "",
        };
    },
    async mounted() {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState == 4 && xhttp.status == 200) {

                this.tycos = xhttp.responseText
                    .replace("{", "")
                    .replace('"body":"', "")
                    .replace('";', "")
                    .replace('}', "")
                    .replace("[[urlsitio]]", "https://cartablanca.com.mx/");


            }
        };
        xhttp.open(
            "GET",
            "https://api-mx-marketing.azure-api.net/sitios/tycos?type=2" +
            "?ref=" +
            Math.random() * 9999,
            true,
        );
        xhttp.setRequestHeader('campaign', 'general');
        xhttp.send();
    },
    props: {
        visible: {
            type: Boolean,
        },
    },
}
</script>

<style lang="css">
.Terms-logoTycos {
    width: 85px;
    position: absolute 40px 30px;
}


.TermsTextTycosFront {
    margin-bottom: 30px;
    text-align: justify;
    max-width: 960px;
    margin: 0 auto;
    color: #464646;
    width: 75vw;
}

.TermsTextTycosFront>div>table {
    width: 100% !important;
    border-collapse: collapse !important;
    border-collapse: collapse;
    border-spacing: 0;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 2.5rem 0;
    overflow: auto;
    padding: 1rem
}

.TermsTextTycosFront th,
td,
tr {
    border: 1px solid;
    font-size: 1.2vw !important;
    padding: 5px;
}

.TermsTextTycosFront h2,
h3,
p {
    margin: 0;
}

.TermsTextTycosFront
h3 {
    text-transform: uppercase;
}

.TermsTextTycosFront h2 {
    font-size: 19px;
    font-weight: 900;
    line-height: 1.2em;
    margin-bottom: 1em;
    color: WESTAR;
}

.TermsTextTycosFront h3 {
    letter-spacing: 0.1em;
}

.TermsTextTycosFront p {
    margin-bottom: 1.5em;
    font-size: 19px;
}

.TermsTextTycosFront h1 {
    font-size: 1.3em !important;
}

.TermsTextTycosFront ul {
    font-size: 19px;
}
</style>
